import API from '@/api'
import { setImageDimensions } from '../utils'

const state = {
  item: {},
  promises: {
    fetch: null,
  },
}

const mutations = {
  set(state, payload) {
    state.item = payload
  },
  setPromise(state, { key, promise }) {
    state.promises[key] = promise
  },
}

const actions = {
  fetch({ commit, state }) {
    if (state.item.id) return state.item
    let promise = API.getRoot().then(async data => {
      data.media.gallery = await setImageDimensions(data.media.gallery)
      commit('set', data)
      return data
    })
    commit('setPromise', { key: 'fetch', promise })
    return promise
  },
  forceFetchRoot({ commit, state }) {
    let promise = API.getRoot().then(async data => {
      data.media.gallery = await setImageDimensions(data.media.gallery)

      commit('set', data)
      return data
    })
    commit('setPromise', { key: 'fetch', promise })
    return promise
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
